module.exports = __webpack_public_path__ + "img/menu2.f8391a4e.png";